export const bsaBatchStatuses = [
  { label: 'New', value: 'new' },
  { label: 'Submitted', value: 'submitted' },
  { label: 'Acknowledged with warnings', value: 'acknowledged_with_warnings' },
  { label: 'Acknowledged', value: 'acknowledged' }
]
